"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _kDsFoundation = _interopRequireDefault(require("../../lib/k-ds-foundation"));
var _excluded = ["className", "children", "color", "thickness", "height", "width", "margin"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var HorizontalDivider = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "kds-v1__sc-juhhfp-0"
})(["border-style:solid;", " ", " ", " ", ""], function (props) {
  return props.color && (0, _styledComponents.css)(["", ""], _kDsFoundation["default"].setColorTokenWithFallback('border-color: ', props.color));
}, function (props) {
  return props.thickness && (0, _styledComponents.css)(["border-width:0px 0px ", " 0px;"], props.thickness);
}, function (props) {
  return props.width && (0, _styledComponents.css)(["width:", ";"], props.width);
}, function (props) {
  return props.margin && props.margin !== '0' && (0, _styledComponents.css)(["", ";"], _kDsFoundation["default"].setSpacingWithFallback('margin: ', props.margin, 0)) || props.margin && props.margin === '0' && (0, _styledComponents.css)(["margin:0 0;"]);
});
var VerticalDivider = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "kds-v1__sc-juhhfp-1"
})(["display:inline-block;border-style:solid;", " ", " ", " ", ""], function (props) {
  return props.color && (0, _styledComponents.css)(["", ""], _kDsFoundation["default"].setColorTokenWithFallback('border-color: ', props.color));
}, function (props) {
  return props.thickness && (0, _styledComponents.css)(["border-width:0px ", " 0px 0px;"], props.thickness);
}, function (props) {
  return props.height && (0, _styledComponents.css)(["height:", ";"], props.height);
}, function (props) {
  return props.margin && (0, _styledComponents.css)(["margin:0 ", ";"], props.margin);
});
var Divider = exports.Divider = function Divider(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'border' : _ref$color,
    _ref$thickness = _ref.thickness,
    thickness = _ref$thickness === void 0 ? '2px' : _ref$thickness,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '1.4ch' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    margin = _ref.margin,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  var DividerComponent;
  var marginSpace = '0';
  switch (moreProps.type) {
    case 'vertical':
      DividerComponent = VerticalDivider;
      marginSpace = 'spacing-03';
      break;
    case 'horizontal':
    default:
      DividerComponent = HorizontalDivider;
      marginSpace = 'layout-01';
  }
  return /*#__PURE__*/_react["default"].createElement(DividerComponent, _extends({
    className: className
  }, moreProps, {
    color: color,
    thickness: thickness,
    height: height,
    width: width,
    margin: margin || marginSpace
  }), children);
};